export default "__VITE_PUBLIC_ASSET__435572d9__"